"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgBeach = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { clipRule: 'evenodd', d: 'M12.502 15.285c.607-.496 1.157-1.412 1.65-2.749.513 4.336.788 6.824.824 7.463h6.026c.666 0 1 .334 1 1.001 0 .667-.334 1-1 1H2.998c-.664 0-.997-.333-.998-.997-.001-.664.333-.998 1.002-1.001h9.99c-.067-1.295-.49-4.717-.49-4.717zm-3.2-7.77C8.056 7.812 7.244 8.58 6.869 9.82c-.564 1.859.35 3.445.35 3.445-.656.245-1.452.296-2.389.15-.627-1.804-.354-3.53.82-5.178 1.173-1.649 2.821-2.442 4.945-2.38 1.303-2.289 3.263-3.202 5.879-2.74 3.925.691 4.505 4.296 4.505 4.296-.336.383-.782.714-1.339.992-.501-1.71-1.53-2.885-3.085-3.526-1.554-.64-3.126-.439-4.714.605 1.92-.138 3.49.218 4.714 1.07 1.757 1.26 2.436 3.079 2.038 5.458a5.011 5.011 0 01-3.254-.222c-1.061-.437-1.854-1.142-2.377-2.115.145.56.167 1.266.065 2.115-.278 2.14-2.432 3.427-2.432 3.427s-1.975-.941-2.392-3.427c-.278-1.657.089-3.082 1.1-4.275h-.001z' }))); };
exports.default = SvgBeach;
//# sourceMappingURL=Beach.js.map